import { memo } from 'react'
import { ErrorMessage, Label, Select, type SelectOption } from '../../atoms'

interface SelectFieldProps {
  id: string
  label: string
  name?: string
  value: string
  onChange: (value: string) => void
  options: SelectOption[]
  error?: string
  hint?: string
  skeleton?: boolean
}

// Label + Select + hint/error, the select twin of FormField: the visible helper text (the error
// replaces the hint) is what the select is described by
export const SelectField = memo(
  ({ id, label, name, value, onChange, options, error, hint, skeleton }: SelectFieldProps) => {
    if (skeleton) {
      return (
        <div className="form-group">
          <span className="form-label">{label}</span>
          <Select skeleton options={[]} />
        </div>
      )
    }
    const hintId = `${id}-hint`
    const errorId = `${id}-error`
    return (
      <div className="form-group">
        <Label htmlFor={id}>{label}</Label>
        <Select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          error={!!error}
          aria-describedby={error ? errorId : hint ? hintId : undefined}
        />
        {hint && !error ? (
          <span id={hintId} className="form-hint">
            {hint}
          </span>
        ) : null}
        <ErrorMessage id={errorId} message={error} />
      </div>
    )
  },
)

SelectField.displayName = 'SelectField'
